<!--template for the modal component-->
<template>
    <div v-if="bShowDialog" v-on:close="bShowDialog = false">
        <transition name="modal">
            <div class="modal-mask">
                <div class="modal-wrapper">
                    <div class="modal-container">

                        <div class="modal-header">
                            <h2>{{strHeaderDialogText}}</h2>
                        </div>

                        <div class="modal-body text-justify">
                            <p v-if="strBody" v-html="strBody"></p>
                            <div v-if="strObs.length > 0">
                                <ul v-for="item in strObs">
                                    <li style="font-size: 14px;" v-html="item"></li>
                                </ul>
                            </div>
                        </div>

                        <div class="modal-footer" v-if="!strRedirect">
                            <button type="button" class="btn btn-secondary" v-on:click="bShowDialog = false">Cerrar</button>
                        </div>
                        <div class="modal-footer" v-else="strRedirect">
                            <button type="button" class="btn btn-primary" v-on:click="Redirect(strRedirect)">Aceptar</button>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    module.exports = {
        name: "dialogg",
        data: function () {
            return {
                bShowDialog: false,
                strHeaderDialogText: '',
                strBody: '',
                strRedirect: '',
                strObs: [],
            }
        },
        watch: {
            bShowDialog: {
                immediate: true,
                handler: function (val, oldVal) {
                    if (val) {
                        document.ontouchmove = function (e) { e.preventDefault(); }
                        document.body.style.overflow = "hidden"; 
                    } else {
                        document.ontouchmove = function (e) { return true; }
                        document.body.style.overflow = "inherit";
                    }
                }
            },
        },
        methods: {
            showDialog: function (encabezado, mensaje, redireccion) {

                document.body.scrollTop = 0; // For Safari
                document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera

                this.bShowDialog = true;

                this.strHeaderDialogText = "";
                this.strObs = [];
                this.strBody = "";
                this.strRedirect = "";

                this.strHeaderDialogText = encabezado;

                if (Array.isArray(mensaje)) {
                    this.strObs = mensaje;
                } else {
                    this.strBody = mensaje;
                }

                this.strRedirect = redireccion;
            },
            Redirect: function (strRedireccion) {
                window.location = strRedireccion;
            }
        }
    }
</script>

<style>

    .loader {
        border: 16px solid #f3f3f3; /* Light grey */
        border-top: 16px solid #3498db; /* Blue */
        border-radius: 50%;
        width: 120px;
        height: 120px;
        animation: spin 2s linear infinite;
    }

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }

        100% {
            transform: rotate(360deg);
        }
    }

    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        width: 500px;
        margin: 0px auto;
        padding: 20px 30px;
        background-color: #fff;
        border-radius: 5px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }

    .modal-header h2 {
        margin-top: 0;
        color: #428bca;
    }

    .modal-body {
        margin: 20px 0;
        position: relative;
        height: auto;
        overflow-y: auto;
        font-size: 16px;
        /*max-height: 300px;*/
    }

    .modal-default-button {
        float: right;
    }

    /*
    * The following styles are auto-applied to elements with
    * transition="modal" when their visibility is toggled
    * by Vue.js.
    *
    * You can easily play with the modal transition by editing
    * these styles.
    */

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

        .modal-enter .modal-container,
        .modal-leave-active .modal-container {
            -webkit-transform: scale(1.1);
            transform: scale(1.1);
        }

    @media screen and (max-height: 380px) {
        .modal-body {
            margin: 20px 0;
            position: relative;
            height: auto;
            overflow-y: auto;
            font-size: 16px;
            max-height: 100px;
        }
    }

    @media screen and (max-width: 1024px) {
        .modal-container {
            width: 80% !important;
            padding: 0 !important;
        }
    }

</style>



// WEBPACK FOOTER //
// Scripts/js/components/dialogGeneral.vue